module.exports = __webpack_public_path__ + "img/aspen-spring.325bb46b.png";